import React, { useLayoutEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router';
import NotFound from '~/components/NotFound/NotFound.tsx';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.tsx';
import HeaderMainPage from '~/modules/main-page/HeaderMainPage/HeaderMainPage.tsx';
import { styles } from '~/modules/styles.ts';

interface IGuaranteesClientLayoutProps {
  children?: React.ReactNode;
}

const GuaranteesClientLayout: React.FC<IGuaranteesClientLayoutProps> = ({ children }) => {
  const location = useLocation();
  const { isGuaranteesEnabled } = useFeatureFlags();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  if (!isGuaranteesEnabled) {
    return <NotFound />;
  }

  return (
    <Box sx={styles.contentPanel}>
      <Box sx={{ minHeight: '100vh' }}>
        <HeaderMainPage />
        <Box component="main">{children ?? <Outlet />}</Box>
      </Box>
    </Box>
  );
};

export default GuaranteesClientLayout;
